import { render } from "./DaoYou.vue?vue&type=template&id=c52f30c0"
import script from "./DaoYou.vue?vue&type=script&lang=js"
export * from "./DaoYou.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__